import { render, staticRenderFns } from "./InformeView.vue?vue&type=template&id=b7f2eb68&scoped=true&"
import script from "./InformeView.vue?vue&type=script&lang=js&"
export * from "./InformeView.vue?vue&type=script&lang=js&"
import style0 from "./InformeView.vue?vue&type=style&index=0&id=b7f2eb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f2eb68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VToolbar,
  VToolbarTitle,
})
